module.exports = __webpack_public_path__ + "static/media/tim.5769dade.gif";